function reloadPage(event) {
  setTimeout(() => {
    window.location.reload();
  }, 500);
}

function initializeCategoryScroll() {
  const categoriesWrapper = document.querySelector('.categories-wrapper');
  const scrollButtonLeft = document.querySelector('.scroll-button-left');
  const scrollButtonRight = document.querySelector('.scroll-button-right');

  // If any required element is missing, exit gracefully
  if (!categoriesWrapper || !scrollButtonLeft || !scrollButtonRight) {
    return;
  }

  const scrollAmount = 200;

  scrollButtonLeft.addEventListener('click', () => {
    categoriesWrapper.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  });

  scrollButtonRight.addEventListener('click', () => {
    categoriesWrapper.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  });

  function updateArrows() {
    const maxScroll = categoriesWrapper.scrollWidth - categoriesWrapper.clientWidth;
    scrollButtonLeft.style.display = categoriesWrapper.scrollLeft > 0 ? 'flex' : 'none';
    scrollButtonRight.style.display = categoriesWrapper.scrollLeft < maxScroll ? 'flex' : 'none';
  }

  updateArrows();
  categoriesWrapper.addEventListener('scroll', updateArrows);
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', initializeCategoryScroll);

// Re-initialize after Shopify section updates
document.addEventListener('shopify:section:load', initializeCategoryScroll);

// Expose function for external use (like after filter updates)
window.reinitializeCategoryScroll = initializeCategoryScroll;
